import { ReactNode } from 'react';
import styled from 'styled-components';

export const Modal = ({
  isOpen,
  children,
  label,
  onClose,
}: {
  isOpen: boolean;
  children?: ReactNode;
  label?: string;
  onClose?: () => void;
}) => {
  return (
    <Container $isOpen={isOpen}>
      <Backdrop onClick={onClose} />

      <Content className="scroll">
        <Label>
          {label}
          <CloseButton onClick={onClose}>
            <i className="icon-x" />
          </CloseButton>
        </Label>

        {children}
      </Content>
    </Container>
  );
};

const Container = styled.div<{ $isOpen: boolean }>`
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  display: flex;
  align-items: center;
  justify-content: center;

  background-color: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);

  transition: opacity 0.3s;
  ${({ $isOpen }) => !$isOpen && `
    opacity: 0;
    pointer-events: none;
    
    * {
      pointer-events: none !important;
    }
  `}
`;

const Backdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

const Content = styled.div`
  position: relative;
  box-sizing: border-box;
  width: 500px;
  max-width: 500px;
  max-height: calc(100vh - 120px);
  overflow-y: auto;
  overflow-x: hidden;
  padding: 20px;
  padding-top: 0;

  font-family: var(--font-1);
  color: var(--main-2);
  font-size: 14px;

  background-color: var(--neutral-2);
  border: 1px solid var(--neutral-3);
  border-radius: var(--radius-2);

  box-shadow: var(--shadow-1);
`;

const Label = styled.div`
  box-sizing: border-box;
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
  padding: 20px 0;
  z-index: 1;

  background-color: var(--neutral-2);

  font-family: var(--font-1);
  color: var(--main-1);
  font-size: 18px;
`;

const CloseButton = styled.div`
  position: absolute;
  top: 0;
  right: -20px;
  cursor: pointer;
  padding: 20px;

  font-family: var(--font-1);
  color: var(--main-2);
  font-size: 14px;

  transition: color 0.3s;

  &:hover {
    color: var(--main-1);
  }
`;
